<pt-file-upload (fileUploaded)="fileUploaded($event)" />
